import { render, staticRenderFns } from "./logistics_company_list.vue?vue&type=template&id=c5c98e04"
import script from "./logistics_company_list.vue?vue&type=script&lang=js"
export * from "./logistics_company_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports